import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { icReviewStatusEnumOptions } from '~/shared/config/constants'
import {
  AutocompleteInput,
  DatePickerInput,
  NumericInput,
  TextInput,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type InsuranceProps = {
  disabled: boolean
  loading: boolean
}

export function Insurance({ disabled, loading }: InsuranceProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.insurance')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <TextInput
            label='form.documents submission ic'
            placeholder='form.documents submission ic'
            name='documentsSubmissionIc'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <NumericInput
            label='form.loss number'
            placeholder='form.enter loss number'
            name='lossNumber'
            readOnly={disabled}
            skeletonShow={loading}
            numericProps={{ thousandSeparator: '', decimalScale: 0 }}
          />
        </Grid>

        <Grid xs={4}>
          <DatePickerInput
            label='form.ic appeal date'
            placeholder='form.select ic appeal date'
            name='icAppealDate'
            skeletonShow={loading}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.ic inspection date'
            placeholder='form.select ic inspection date'
            name='icInspectionDate'
            skeletonShow={loading}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={4}>
          <AutocompleteInput
            options={icReviewStatusEnumOptions}
            label='form.ic review status'
            placeholder='form.select ic review status'
            name='icReviewStatus'
            readOnly={disabled}
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            name='reimbursedBySecurityService'
            placeholder='form.enter security service writeoff'
            label='form.security service writeoff'
            skeletonShow={loading}
            readOnly={disabled}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
